import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOMeta from '@/components/feature/SEOMeta';
import HeroSection from './components/HeroSection';
import FeaturedProducts from './components/FeaturedProducts';
import CategoryNav from './components/CategoryNav';
import ArticleRecommend from './components/ArticleRecommend';
import BrandAdvantage from './components/BrandAdvantage';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

export default function Home() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <SEOMeta
        title="成人精品 | 高品质成人精品精选推荐 - 臻品阁"
        description="探索顶级成人精品，甄选全球高品质成人精品产品，安全私密、品质保障。无论您追求品味还是功能，我们的成人精品系列满足您的多元需求，专业选品，贴心服务，让每一次体验都臻于完美。"
        keywords="成人精品,成人精品推荐,高品质成人精品,成人精品购买,成人精品品牌,进口成人精品,成人精品评测"
        canonicalUrl="https://www.example.com/"
      />

      {/* Organization Schema */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Organization',
            name: '臻品阁',
            url: 'https://www.example.com',
            description: '高品质成人精品精选平台，安全私密、品质保障',
            contactPoint: {
              '@type': 'ContactPoint',
              contactType: 'customer service',
              availableLanguage: ['Chinese'],
            },
          }),
        }}
      />

      {/* WebSite Schema */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            name: '臻品阁',
            url: 'https://www.example.com',
            description: '高品质成人精品精选推荐平台',
            inLanguage: 'zh-Hans',
          }),
        }}
      />

      {/* WebPage Schema */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: '臻品阁 - 高品质成人精品精选推荐',
            description: '探索顶级成人精品，甄选全球高品质成人精品产品，安全私密、品质保障。',
            url: 'https://www.example.com/',
            isPartOf: {
              '@type': 'WebSite',
              name: '臻品阁',
              url: 'https://www.example.com',
            },
            breadcrumb: {
              '@type': 'BreadcrumbList',
              itemListElement: [
                {
                  '@type': 'ListItem',
                  position: 1,
                  name: '首页',
                  item: 'https://www.example.com/',
                },
              ],
            },
          }),
        }}
      />

      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroSection />
          <FeaturedProducts />
          <CategoryNav />
          <BrandAdvantage />
          <ArticleRecommend />
          <FAQSection />
          <CTASection />
        </main>
        <Footer />
      </div>
    </>
  );
}